<template>
  <div class="dimed">
    <div class="layer layer--sm">
      <div class="layer__body">
        <div class="ft--xlg ft--bold">
          {{title}}<br />
          {{content}}
        </div>
      </div>

      <div class="layer__button">
        <button class="btn btn--xlg btn--admin btn-anim" @mouseup="$emit('closeRegis')">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'registrationFinish',
  data() {
    return {
      title : '',
      content : '',
    };
  },
  mounted() {
    if(this.settleType === 'USED_SALE'){
      this.title    = this.$t('User.Order.msg28');
      this.content  = this.$t('User.Order.msg44');
    }else{
      this.title    = this.$t('User.Order.msg29');
      this.content  = this.$t('User.Order.msg44');
    }
  },
  props: {
    settleType : String,
  },
  methods: {},
  watch: {},
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src='@/assets/css/user/pages/admin.css' scoped></style>
<style scoped></style>
